import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isPageviewTrackingActive, trackPageview } from './analytics';

// Meldet jeden SPA-Routenwechsel als Pageview an /api/tracking/pageview.
//
// Warum ueberhaupt: Die Legacy-Vanilla-Web hatte pro HTML-Seite einen echten
// Seitenaufruf; die SPA navigiert clientseitig und erzeugte seit dem Cutover
// (v7.1.1.14) NULL Pageviews — das Admin-Tracking sah den kompletten Web-Kanal
// nicht mehr, obwohl die Server-Route unveraendert weiterlebt.
//
// Ob wirklich gesendet wird, entscheidet analytics.ts (Consent bzw. Login,
// nie in der nativen App) — trackPageview ist sonst ein No-op.
export function PageviewTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // isPageviewTrackingActive() haengt am Consent/Login-Zustand und kann sich
    // waehrend der Sitzung aendern (Banner-Klick) — deshalb bei jedem Wechsel
    // erneut fragen, statt einmalig zu entscheiden.
    if (!isPageviewTrackingActive()) return;
    // Die Query kann Zahlungs-/Session-Parameter enthalten (?session_id=…) —
    // die haben im Tracking nichts verloren, also nur der Pfad.
    void search;
    trackPageview(pathname);
  }, [pathname, search]);

  return null;
}
